var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 22.0005L4.5 30L9 18L0 11.25H11.25L15 0L18.75 11.25H30L21 18L25.5 30L15 22.0005Z","fill":"#006666"}));
}

Star.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Star;

Star.default = Star;
